module.exports = __webpack_public_path__ + "img/typeall.d0ece2df.png";